module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_03-be77c9034842c2d80419324bbd97ba85.png";